import {computed, makeObservable} from "mobx";
import {COMPETITION_CONTAINER} from "../../../containers/competition-container/competition-container.consts";
import {NEW_COMPETITOR_CONTAINER} from "../../../containers/competitor-container/competitor-container.consts";
import {PAGES, ROUTE_NAMES, SCREEN_RESOLUTION} from "../../../core/consts";
import {RouterController} from "../../../core/components/router/router-controller";
import {BaseModel} from "../../../infrastructure/models/base-model";
import {DeviceViewModel} from "../../../core/models/device.view-model";
import {BaseLinkModel} from "../../../infrastructure/models/link/base-link-model";
import {NavigationManager} from "../../../core/managers/navigation-manager";

export class WebsiteModuleDisplayModel extends BaseModel {

  static injectables = [DeviceViewModel, RouterController, NavigationManager];

  constructor(device: DeviceViewModel, routerController: RouterController, navigationManager: NavigationManager) {
    super();

    this.device = device;
    this.routerController = routerController;
    this.navigationManager = navigationManager;

    makeObservable(this);
  }

  @computed get currentLinkModel(): BaseLinkModel {
    return this.navigationManager.currentLinkModel;
  }

  @computed get isNewEntitiesPages(): Boolean {
    return this.isCompetitionPage || this.isCompetitorPage || this.isGameCenterPage
  }

  @computed get isGameCenterPage(): Boolean {
    return [ROUTE_NAMES.gameCenterPage, Object.values(PAGES.GAME_CENTER)].flat()?.includes((this.currentLinkModel?.name))
  }

  @computed get isCompetitionPage(): Boolean {
    return [ROUTE_NAMES.competition, Object.values(PAGES.COMPETITION)].flat()?.includes((this.currentLinkModel?.name))
  }

  @computed get isCompetitorPage(): Boolean {
    return [ROUTE_NAMES.competitor, Object.values(PAGES.COMPETITION)].flat()?.includes((this.currentLinkModel?.name))
  }

  @computed get shouldHideBars(): Boolean {
    const isBracketsHashParams: Boolean = this.currentLinkModel?.hashParams?.brackets === NEW_COMPETITOR_CONTAINER.FILTERS.brackets;
    const isCurrentRouteMatchValid = this.routerController.isCurrentRouteMatchValid;
    const validRoutes = [ROUTE_NAMES.pages, ROUTE_NAMES.pageNotFound, ROUTE_NAMES.bolao, ROUTE_NAMES.competition, Object.values(PAGES.COMPETITION)].flat();
    const validFilters = [COMPETITION_CONTAINER.FILTERS.matches, COMPETITION_CONTAINER.FILTERS.brackets];
    const shouldHideBars: Boolean = validRoutes.includes(this.currentLinkModel?.name) || validFilters.includes(this.currentLinkModel?.params?.filter) || !isCurrentRouteMatchValid || isBracketsHashParams;

    return shouldHideBars || this.isCompetitionPage || this.isCompetitorPage || this.isGameCenterPage
  }

  @computed get sideBarVisible() {
    const sideBarVisible: Boolean = SCREEN_RESOLUTION.md_max < this.device.screenWidth && !this.shouldHideBars && !this.isBettingZone;

    return sideBarVisible;
  }

  @computed get noBarsVisible() {
    return !this.sideBarVisible && this.shouldHideBars
  }

  @computed get isBolao(): Boolean {
    return this.currentLinkModel?.name === ROUTE_NAMES.bolao;
  }

  @computed get isBettingZone(): Boolean {
    const bettingPages: Array<ROUTE_NAMES> = [ROUTE_NAMES.betting, ...(Object.values(PAGES.BETTING))];

    return bettingPages.includes(this.currentLinkModel?.name);
  }
}
